import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
const team = [{
  name: 'Dr. Thomas Schwenk',
  role: 'Inhaber / Ästhetik & Funktion',
  offset: 'mt-0',
  parallaxRange: ['0px', '-20px']
}, {
  name: 'Dr. Markus Striegel',
  role: 'Inhaber / Ästhetik & Funktion',
  offset: 'mt-16 md:mt-32',
  parallaxRange: ['0px', '-40px']
}, {
  name: 'Dr. Johanna Herzog M.Sc.',
  role: 'Inhaberin / Kieferorthopädie',
  offset: 'mt-8 md:mt-16',
  parallaxRange: ['0px', '-30px']
}];
export function TeamSection() {
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y1 = useTransform(scrollYProgress, [0, 1], team[0].parallaxRange);
  const y2 = useTransform(scrollYProgress, [0, 1], team[1].parallaxRange);
  const y3 = useTransform(scrollYProgress, [0, 1], team[2].parallaxRange);
  const transforms = [y1, y2, y3];
  return <section ref={ref} className="py-32 bg-weiss border-t border-gray-200 overflow-hidden" data-id="element-196">
      <div className="max-w-7xl mx-auto px-6" data-id="element-197">
        <div className="mb-20 max-w-2xl" data-id="element-198">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-poppins font-bold text-schwarz mb-6 uppercase tracking-tight" data-id="element-199">
            Unser Team
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-medium font-lora" data-id="element-200">
            Ihre Zahnärztinnen und Zahnärzte in Nürnberg, Fürth und Erlangen.
            Bei uns arbeiten ausnahmslos Experten, die in ihrem jeweiligen
            Fachgebiet über herausragende Expertise verfügen.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-201">
          {team.map((member, index) => <motion.div key={index} style={{
          y: transforms[index],
          willChange: 'transform'
        }} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className={`group cursor-pointer team-card-shine pb-4 ${member.offset}`} data-id="element-202">
              <div className="relative overflow-hidden aspect-[3/4] mb-6 bg-beige border border-gray-200" data-id="element-203">
                <div className="absolute inset-0 bg-navy/5 group-hover:bg-navy/0 transition-colors duration-500" data-id="element-204" />
                <motion.div className="absolute inset-0 bg-gradient-to-t from-schwarz/90 via-schwarz/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-8" data-id="element-205">
                  <p className="text-weiss text-sm font-lora translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-206">
                    Spezialisiert auf zukunftsweisende Zahnmedizin und
                    individuelle Betreuung auf höchstem Niveau.
                  </p>
                </motion.div>
              </div>
              <h3 className="text-2xl font-poppins font-bold text-schwarz mb-2" data-id="element-207">
                {member.name}
              </h3>
              <p className="text-navy font-lora font-bold text-sm uppercase tracking-widest" data-id="element-208">
                {member.role}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}